import { useMemo } from 'react';

import { useIntl } from 'react-intl';
import { definedTranslation } from '../i18n';

export function useLabels() {
  const intl = useIntl();

  const textLabels = useMemo(
    () => ({
      shipping: {
        stock: intl.formatMessage(definedTranslation.shipping.stock),
        oos: intl.formatMessage(definedTranslation.shipping.oos),
      },
      notAddedToCart: intl.formatMessage(
        definedTranslation.notAddedToCartLabel,
      ),
      addedToCart: intl.formatMessage(definedTranslation.addedToCartLabel),
      sustainabilityStarLabel: intl.formatMessage(
        definedTranslation.sustainabilityStarLabel,
      ),
      sustainabilitySecondLabel: intl.formatMessage(
        definedTranslation.sustainabilitySecondLabel,
      ),
      reduceEmissionsLabel: intl.formatMessage(
        definedTranslation.reduceEmissionsLabel,
      ),
      reduceEmissionsSecondLabel: intl.formatMessage(
        definedTranslation.reduceEmissionsSecondLabel,
      ),
      bannerSubtitleDefaultText: intl.formatMessage(
        definedTranslation.bannerSubtitleDefaultText,
      ),
      recommendedTitleLabel: intl.formatMessage(definedTranslation.mainTitle),
      bottomBannerTitle: intl.formatMessage(
        definedTranslation.bottomBannerTitle,
      ),
      bottomBannerSubtitle: intl.formatMessage(
        definedTranslation.bottomBannerSubtitle,
      ),
      selectProjectMessage: intl.formatMessage(
        definedTranslation.pleaseSelectProjectMessage,
      ),
    }),
    [intl],
  );

  return { textLabels };
}
